import * as yup from 'yup'
import { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Rating, Snackbar } from '@mui/material'
import { FormArea, FeildWraper, FeildError, FormLabel, SelectSearch } from '../../../component/form/form-layout'
import { useApiCall } from '../../../component/custom-hooks/api-call';

const AddVendorPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, Style }) => {
    const apiCall = useApiCall();
    const [alertData, setAlertData] = useState({ isShow: false });
    const validationSchema = yup.object().shape({
        companyName: yup.string().required('This Field is required'),
        fullName: yup.string().required('This Field is required'),
        type: yup.string().required('This Field is required'),
    });

    useEffect(() => {
        if (currentData?.id) {
            formik.setFieldValue("companyName", currentData?.company_name)
            formik.setFieldValue("fullName", currentData?.full_name)
            formik.setFieldValue("email", currentData?.email)
            formik.setFieldValue("phone", currentData?.phone_number)
            formik.setFieldValue("rating", currentData?.rating)
            formik.setFieldValue("address", currentData?.address)
            formik.setFieldValue("type", currentData?.type)
        }
    }, [currentData?.id])

    const handleClose = () => {
        setAlertData({ isShow: false })
    }

    const formik = useFormik({
        initialValues: {
            companyName: "",
            fullName: "",
            email: "",
            phone: "",
            rating: "",
            address: "",
            type: ""
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            const apiData = JSON.stringify({
                "company_name": values?.companyName,
                "full_name": values?.fullName,
                "email": values?.email,
                "phone_number": `${values?.phone}`,
                "address": values?.address,
                "rating": `${values?.rating}`,
                "type": values?.type
            });

            try {
                const resp = await apiCall({ method: "post", url: currentData?.id ? `update-vendor/${currentData?.id}` : `store-vendor`, data: apiData });
                onSubmit(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FeildWraper>
                            <FormLabel required>Company Name</FormLabel>
                            <input
                                type={'text'}
                                name={'companyName'}
                                onChange={formik.handleChange}
                                value={formik.values.companyName}
                                placeholder='Company Name'
                            />
                            {formik.touched.companyName && formik.errors.companyName && (
                                <FeildError>{formik.errors.companyName}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Full Name</FormLabel>
                            <input
                                type={'text'}
                                name={'fullName'}
                                onChange={formik.handleChange}
                                value={formik.values.fullName}
                                placeholder='Full Name'
                            />
                            {formik.touched.fullName && formik.errors.fullName && (
                                <FeildError>{formik.errors.fullName}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Email</FormLabel>
                            <input
                                type={'email'}
                                name={'email'}
                                onChange={formik.handleChange}
                                value={formik.values.email}
                                placeholder='Email'
                            />
                            {formik.touched.email && formik.errors.email && (
                                <FeildError>{formik.errors.email}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Phone Number</FormLabel>
                            <input
                                type={'number'}
                                name={'phone'}
                                onChange={formik.handleChange}
                                value={formik.values.phone}
                                placeholder='Phone Number'
                            />
                            {formik.touched.phone && formik.errors.phone && (
                                <FeildError>{formik.errors.phone}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Type</FormLabel>

                            <SelectSearch
                                name="type"
                                placeholder="- Select Type -"
                                onChange={(val) => {
                                    formik.setFieldValue("type", val);
                                }}
                                value={formik.values.type}
                                options={[
                                    {label: "Stock And Supply", value: "stock_and_supply"},
                                    {label: "Generator Fuel", value: "generator_fuel"},
                                    {label: "Water Tanker", value: "water_tanker"},
                                    {label: "Office Assets", value: "office_assets"}
                                ]}
                            />
                            {formik.touched.type && formik.errors.type && (
                                <FeildError>{formik.errors.type}</FeildError>
                            )}
                        </FeildWraper>

                        <div className='flex flex-col gap-[15px] py-[12px] px-[10px]'>
                            <FormLabel>Rating</FormLabel>
                            <Rating
                                name="simple-controlled"
                                size="large"
                                value={formik.values?.rating}
                                onChange={(event, newValue) => {
                                    // setValue(newValue);
                                    formik.setFieldValue("rating", newValue)
                                }}
                            />
                            {formik.touched.rating && formik.errors.rating && (
                                <FeildError>{formik.errors.rating}</FeildError>
                            )}
                        </div>

                        <FeildWraper width='100%'>
                            <FormLabel required>Address</FormLabel>
                            <textarea
                                type={'text'}
                                name={'address'}
                                onChange={formik.handleChange}
                                value={formik.values.address}
                                placeholder='Address'
                            />
                            {formik.touched.address && formik.errors.address && (
                                <FeildError>{formik.errors.address}</FeildError>
                            )}
                        </FeildWraper>
                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
                    <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
                </div>
            </form>

            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default AddVendorPopup
